export default function Footer() {
  // prettier-ignore
  const names = '| Eduardo José Pereira Matos Passos | Gabriel da Costa Filipe Carvalho | Guilherme Moura Pinho Andrade Silva | João Miguel Peixoto Lamas | Valentina Pereira Cadime | Vasco Ferreira da Rocha Melo';

  return (
    <footer className="fixed bottom-0 left-0 w-full px-2 py-2 text-sm font-semibold bg-gray dark:bg-darkgray text-darkgray dark:text-gray overflow-hidden z-50">
      <style>{`
        .tv-marquee { display: flex; width: 100%; will-change: transform; animation: scroll-left 25s linear infinite; }
        .tv-marquee .repeat { display: inline-flex; white-space: nowrap; padding-right: 0.25em;}
        @keyframes scroll-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
      `}</style>

      <div>
        <div className="tv-marquee">
          <div className="repeat">{names}</div>
          <div className="repeat">{names}</div>
          <div className="hidden lg:inline-flex repeat">{names}</div>
          <div className="hidden lg:inline-flex repeat">{names}</div>
        </div>
      </div>
    </footer>
  );
}
